import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, PhoneIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function PricingSection() {
  const features = ['24/7 AI receptionist to answer and route your calls.', 'Custom scripting and call flows tailored to your business.', 'Appointment booking directly into your calendar.', 'Onboarding, setup, and support from Viridia Analytics.'];
  return <section className="py-20 bg-gray-50" data-id="element-139">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        <div className="text-center mb-12" data-id="element-141">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-142">
            Your AI Receptionist Plan
          </motion.h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-lg mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border border-viridia-100 relative" data-id="element-143">
          <div className="absolute top-0 left-0 right-0 h-2 bg-viridia-500" data-id="element-144" />

          <div className="p-8 md:p-10 text-center" data-id="element-145">
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-146">
              AI Receptionist Plan
            </h3>
            <div className="flex items-baseline justify-center gap-1 mb-2" data-id="element-147">
              <span className="text-5xl font-bold text-gray-900" data-id="element-148">$697</span>
              <span className="text-gray-500 font-medium" data-id="element-149">/month</span>
            </div>
            <p className="text-sm text-gray-500 mb-8" data-id="element-150">
              Month-to-month. Cancel anytime.
            </p>

            <div className="w-full h-px bg-gray-100 mb-8" data-id="element-151" />

            <ul className="space-y-4 text-left mb-10" data-id="element-152">
              {features.map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-153">
                  <CheckCircleIcon className="w-5 h-5 text-viridia-500 flex-shrink-0 mt-0.5" data-id="element-154" />
                  <span className="text-gray-700" data-id="element-155">{feature}</span>
                </li>)}
            </ul>

            <div className="space-y-4" data-id="element-156">
              <Button variant="primary" size="lg" className="w-full flex items-center justify-center gap-2 shadow-md" onClick={() => window.location.href = 'tel:6233000708'} data-id="element-157">
                <PhoneIcon className="w-5 h-5" data-id="element-158" />
                Call Jessica – Hear the Demo
              </Button>

              <Button variant="secondary" size="lg" className="w-full" onClick={() => window.open('https://api.viridiaanalytics.com/payment-link/699612346c8c04e29116c945', '_blank')} data-id="element-159">
                Get Started for $697/month
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}